import request from './request'

/**
 * 取得共用文件資料。
 * @param {string} type - ['招生簡章', '個人經歷與省思', '學習規劃與研究構想']。
 * @returns {Promise}
 */
function getUniversalFileByType(type) {
  return request({
    url: '/universalFile/getUniversalFileByType',
    method: 'get',
    params: { type },
  })
}

export default {
  getUniversalFileByType,
}
